"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.META_USER_ACTION_APP_NAME = void 0;
const META_USER_ACTION_APP_NAME = exports.META_USER_ACTION_APP_NAME = 'notifications';
